import { render, staticRenderFns } from "./ListaContacto.vue?vue&type=template&id=1c7f624e"
import script from "./ListaContacto.vue?vue&type=script&lang=js"
export * from "./ListaContacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports